import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';

const styles = css``;

class InfiniteScroll extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      invoked: 0,
    };

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.unpause = this.unpause.bind(this);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  isPaused() {
    const { messageAfter } = this.props;
    const { invoked } = this.state;
    return !!messageAfter && (invoked >= messageAfter);
  }

  unpause() {
    const { action } = this.props;
    this.setState({
      invoked: 0,
    }, action);
  }

  handleScroll() {
    const { action, finished } = this.props;
    const rect = this.wrapperRef.getBoundingClientRect();
    const elemTop = rect.top;
    const elemBottom = rect.bottom;

    if (typeof global.window !== 'undefined') {
      // Only completely visible elements return true:
      const isVisible = (elemTop >= 0) && (elemBottom <= global.window.innerHeight);
      if (!this.isPaused() && isVisible && !finished) {
        this.setState({
          invoked: this.state.invoked + 1,
        }, action);
      }
    }
  }


  render() {
    const { message, finished } = this.props;
    return (
      <div className={styles} ref={this.setWrapperRef} style={{ textAlign: 'center' }}>
        {
          this.isPaused() && !finished &&
          <button className="InfiniteScroll_button btn" onClick={this.unpause}>{message}</button>
        }
      </div>
    );
  }
}

InfiniteScroll.propTypes = {
  action: PropTypes.func.isRequired,
  message: PropTypes.string,
  finished: PropTypes.bool.isRequired,
  messageAfter: PropTypes.number,
};

InfiniteScroll.defaultProps = {
  message: 'Load More...',
  messageAfter: 0,
};

export default InfiniteScroll;



// WEBPACK FOOTER //
// ./src/components/InfiniteScroll.js